// extracted by mini-css-extract-plugin
export default {"admin":"Dashboard_admin__Yj1TJ","con":"Dashboard_con__lNb+4","admin2":"Dashboard_admin2__HIOp5"};